import { render } from "./JournalEntityDetails.vue?vue&type=template&id=5263687b&ts=true"
import script from "./JournalEntityDetails.vue?vue&type=script&lang=ts"
export * from "./JournalEntityDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__